import Icon from '../components/Icon.vue'

Icon.register({
  guitar: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.6 54.6L457.4 9.4C444.9-3.1 424.6-3.1 412.1 9.4L344.2 77.3C331.7 89.8 331.7 110.1 344.2 122.6L290 176.7C244.6 147.7 189.6 147.8 156.5 180.9 146.8 190.6 140.1 202.1 136 214.8 129.9 233.6 112.5 247.9 93.3 249.7 69.3 252 47 261.3 29.9 278.5-16.3 324.6-8 407.6 48.2 463.8 104.4 520 187.4 528.2 233.5 482.1 250.7 465 260 442.7 262.3 418.6 264.1 399.5 278.4 382 297.2 375.9 309.9 371.8 321.4 365.1 331.1 355.4 364.2 322.3 364.2 267.3 335.3 221.9L389.5 167.7C402 180.2 422.3 180.2 434.8 167.7L502.7 99.8C515.1 87.4 515.1 67.1 502.6 54.6zM208 352C181.5 352 160 330.5 160 304S181.5 256 208 256 256 277.5 256 304 234.5 352 208 352z'
      }
    ]
  }
})
